export enum GuideServiceState {
  Pending = 1,
  Approved = 2,
  Billed = 3,
  Deleted = 4
};